import { Grid } from "@mui/material";
import React from "react";
import "./ranking.css";

function RankingCard() {
  const rankingData = [
    {
      rankSrc: "./Assets/ranking_1.png",
      vol: "12,4353",
      perc: "+3456%",
      sevenPerc: "	-564%",
      floor: "12,4353 ETH",
      owner: "3.3k",
      assets: "23k",
    },
    {
      rankSrc: "./Assets/ranking_2.png",
      vol: "12,4353",
      perc: "+3456%",
      sevenPerc: "	-564%",
      floor: "12,4353 ETH",
      owner: "3.3k",
      assets: "23k",
    },
    {
      rankSrc: "./Assets/ranking_3.png",
      vol: "12,4353",
      perc: "+3456%",
      sevenPerc: "	-564%",
      floor: "12,4353 ETH",
      owner: "3.3k",
      assets: "23k",
    },
    {
      rankSrc: "./Assets/ranking_4.png",
      vol: "12,4353",
      perc: "+3456%",
      sevenPerc: "	-564%",
      floor: "12,4353 ETH",
      owner: "3.3k",
      assets: "23k",
    },
  ];
  return (
    <div>
      <div className="seprator"></div>
      <Grid container justifyContent="space-between">
        <Grid item lg={3}>
          <p className="table_heads">collection</p>
        </Grid>
        <Grid
          item
          sx={{
            display: {
              xs: "none",
              sm: "none",
              md: "block",
              lg: "block",
            },
          }}
          lg={1}
        >
          <p className="table_heads">Volume</p>
        </Grid>
        <Grid
          item
          lg={1}
          sx={{
            display: {
              xs: "none",
              sm: "none",
              md: "block",
              lg: "block",
            },
          }}
        >
          <p className="table_heads">24h %</p>
        </Grid>
        <Grid
          item
          lg={1}
          sx={{
            display: {
              xs: "none",
              sm: "none",
              md: "block",
              lg: "block",
            },
          }}
        >
          <p className="table_heads">7d %</p>
        </Grid>
        <Grid
          item
          lg={1}
          sx={{
            display: {
              xs: "none",
              sm: "none",
              md: "block",
              lg: "block",
            },
          }}
        >
          <p className="table_heads">Floor Price</p>
        </Grid>
        <Grid
          item
          lg={1}
          sx={{
            display: {
              xs: "none",
              sm: "none",
              md: "block",
              lg: "block",
            },
          }}
        >
          <p className="table_heads">Owners</p>
        </Grid>
        <Grid item lg={1}>
          <p className="table_heads">Assets</p>
        </Grid>
      </Grid>
      <div className="seprator"></div>
      {rankingData.map((e) => {
        return (
          <Grid
            container
            justifyContent="space-between"
            alignItems="center"
            className="rank_con"
          >
            <Grid item lg={3}>
              <div className="img_rank">
                <img src={e.rankSrc} alt="" />
                <span className="rank_id">Creative Art collection</span>
              </div>
            </Grid>
            <Grid
              item
              lg={1}
              sx={{
                display: {
                  xs: "none",
                  sm: "none",
                  md: "block",
                  lg: "block",
                },
              }}
            >
              <p className="table_heads_two">{e.vol}</p>
            </Grid>
            <Grid
              item
              lg={1}
              sx={{
                display: {
                  xs: "none",
                  sm: "none",
                  md: "block",
                  lg: "block",
                },
              }}
            >
              <p className="table_heads_two">{e.perc}</p>
            </Grid>
            <Grid
              item
              lg={1}
              sx={{
                display: {
                  xs: "none",
                  sm: "none",
                  md: "block",
                  lg: "block",
                },
              }}
            >
              <p className="table_heads_two">{e.sevenPerc}</p>
            </Grid>
            <Grid
              item
              lg={1}
              sx={{
                display: {
                  xs: "none",
                  sm: "none",
                  md: "block",
                  lg: "block",
                },
              }}
            >
              <p className="table_heads_two"> {e.floor}</p>
            </Grid>
            <Grid
              item
              lg={1}
              sx={{
                display: {
                  xs: "none",
                  sm: "none",
                  md: "block",
                  lg: "block",
                },
              }}
            >
              <p className="table_heads_two">{e.owner}</p>
            </Grid>
            <Grid item lg={1}>
              <p className="table_heads_two">{e.assets}</p>
            </Grid>
          </Grid>
        );
      })}
    </div>
  );
}

export default RankingCard;
